<template lang="pug">
  #adminsuper-challenge-settings
    WtTile(ancestor vertical)
      WtTile.display-layout(parent :col="12")
        WtTile(child :col="4")
          WtLabel(
            isLabelElement
            text="Challenge Builder"
            :tooltip-text="builderTooltip"
          )
          .level
            .level-left
              .level-item
                WtButton(
                  is-router-link
                  :to="routeObj()"
                ) CREATE A CHALLENGE

        WtTile(child :col="4")
          P2PConverter

</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";
import WtLabel from "@@/WtLabel/WtLabel";
import P2PConverter from "@/components/ChallengeCenterAdminSuper/P2PConverter";

export default {
  name: "AdminSuperChallengeSettings",

  components: { WtLabel, WtTile, WtTitle, WtButton, P2PConverter },

  data() {
    return {
      builderTooltip: `This creates a program-wide challenge. NOTE: you may not create challenges when logged in to other programs.
      `
    };
  },

  methods: {
    routeObj(mode) {
      return {
        name: "AdminSuperChallengeCenterBuilder",
        params: { mode }
      };
    }
  }
};
</script>

<style lang="sass" scoped>
.display-layout
  display: flex !important
  gap: 30px
</style>
